<template>
    <div>
        <div class="content contentMyGoal">
            <BigTitle title='part.2 我的目标'></BigTitle>
            <MiddleTitle title='目标规划'></MiddleTitle>
            <PlanTable :plan="myGoalPlan" ></PlanTable>
        </div>
        <template v-if="Array.isArray(myGoalPlanAdjust)&&myGoalPlanAdjust.length">
            <div class="content contentMyGoal" v-for="(value,index) in myGoalPlanAdjust" :key="index">
                <MiddleTitle title='规划调整' v-if="index==0"></MiddleTitle>
                <SmallTitle :title="value.interviewRecordName"></SmallTitle>
                <PlanTable :plan="value" ></PlanTable>
            </div>
        </template>
    </div>
</template>
<script>
import BigTitle from './bigTitle'
import MiddleTitle from './middleTitle'
import SmallTitle from './smallTitle'
import PlanTable from "./planTable/planTable";
export default {
    props: ['myGoalPlan','myGoalPlanAdjust'],
    name: 'pageGradeList',
    components: {
        PlanTable,BigTitle,MiddleTitle,SmallTitle
    },
    data() {
        return {
            planData: {},
        }
    },
    computed: {

    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>